export const environment = {
  production: true,
  MY_HASH_NAMESPACE: '0f4358f3-794e-46ec-9f80-7c3e6c044447'
};
